const drawing = {

	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * Is the mouse pressed down or not?
	 *
	 * @type {boolean}
	 */
	mousepressed: false,


	/**
	 * Should we update the page url?
	 *
	 * @type {timer}
	 */
	updateUrl_timer: null,


	/**
	 * Initialize the component.
	 */
	init: function() {

		const $comp = document.querySelector( '.emoji-drawing' );

		drawing.app = new Reef(
			$comp,
			{
				data: ninjaData.data,
				template: drawing.template,
				attachTo: [ ninjaData ]
			}
		);

		drawing.load();

		ninjaData.render();

		// $comp.addEventListener( 'click', drawing.click );
		$comp.addEventListener( 'mouseover', drawing.mouseover );
		$comp.addEventListener( 'mousedown', drawing.mousedown );
		document.addEventListener( 'mouseup', drawing.mouseup );
		document.addEventListener( 'reef-set-data', drawing.maybeUpdateUrl );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( props ) {

		let html = '';

		const { width, height } = props;
		const size = dimensions[ props.size ].size;

		const maxGridSize = Math.max( props.height, props.width );
		const fontSize = Math.floor( ( Math.min( size[ 0 ], size[ 1 ] ) - 40 ) / maxGridSize );
		const elementType = 'button';

		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {

				html += `<${elementType}
					class="button ghost"
					type="button"
					data-x="${x}"
					data-y="${y}"
					style="width:${fontSize}px; height:${fontSize}px;"
				>${props.art[ y ][ x ]}</${elementType}>`;

			}
		}

		// const stylesWrapper = `width:${size[ 0 ]}px; height:${size[ 1 ]}px; background-color:${settingsPalette[ props.backgroundColor ]};`;
		const stylesWrapper = [
			`width: ${size[ 0 ]}px`,
			`aspect-ratio: ${size[ 0 ]} / ${size[ 1 ]}`,
			`background-color: ${settingsPalette[ props.backgroundColor ]}`
		];
		const stylesGrid = [
			`font-size: ${fontSize - 2}px`,
			`width: ${props.width * fontSize}px`,
			`line-height: 1`,
			`height: ${props.height * fontSize}px`
		];
		// const stylesGrid = `font-size:1.5em; width:${props.width * fontSize}px; height:${props.height * fontSize}px;`;

		// Change the CSS variables so that the grid is sized correctly.
		const $styleWrapper = document.querySelector( '.emoji-drawing' );
		$styleWrapper.style.setProperty( '--emoji-col-count', width );
		$styleWrapper.style.setProperty( '--emoji-row-count', height );

		return `
		<div id="emoji-art-drawing" class="drawing m-auto overflow-hidden" style="${stylesWrapper.join( '; ' )}">
			<div class="drawing-grid grid gap0" style="${stylesGrid.join( '; ' )}">${html}</div>
		</div>`;

	},


	/**
	 * Load artwork from the url query string.
	 *
	 * @return {void}
	 */
	load: function() {

		// If there's no query string then stop loading.
		let urlParams = new URLSearchParams( window.location.search );
		if ( !urlParams.has( 'l' ) ) {
			return;
		}

		let artList = LZString.decompressFromEncodedURIComponent( urlParams.get( 'l' ) );
		let size = parseInt( urlParams.get( 's' ) );
		let backgroundColor = urlParams.get( 'bg' );

		if ( !artList ) {
			return;
		}

		if ( !size || !artSize[ size ] ) {
			size = 0;
		}

		let newArt = defaultEmojiArt( size );

		const width = artSize[ size ];
		const height = artSize[ size ];
		const currentArtSize = size;

		// @see https://stackoverflow.com/questions/24531751/how-can-i-split-a-string-containing-emoji-into-an-array
		const newLayout = drawing.emojiStringToArray( artList );

		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {

				let e = newLayout.shift();
				if ( drawing.emojiExists( e ) ) {
					newArt[ y ][ x ] = e;
				}

			}
		}

		// Update the data.
		ninjaData.setData(
			{
				width,
				height,
				currentArtSize,
				art: newArt,
				backgroundColor
			}
		);

		undo.reset();

	},


	/**
	 * Generate a serialized string containing all the emojis from the artwork.
	 *
	 * @return {string}
	 */
	emojiArtString: function() {

		let str = '';
		const { width, height, art } = ninjaData.data;

		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {
				str += art[ y ][ x ];
			}
		}

		return str;

	},


	/**
	 * Convert a string of emojis to an array of emojis, and remove empty
	 * instances.
	 *
	 * @param {string} str The string of emojis
	 * @return {array}
	 */
	emojiStringToArray: function( str ) {

		if ( !str ) {
			return [];
		}

		const emojiRegex = drawing.emojiRegex();
		const split_str = str.match( emojiRegex );

		// /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu
		// const split_str = str.match( /\p{Emoji}/gu );

		let arr = [];

		for ( var i = 0; i < split_str.length; i++ ) {
			let char = split_str[ i ];

			/**
			 * Ignore empty strings and 65039.
			 * Who knows what 65039 is? I don't but it seems to be inserting
			 * itself sometimes so we have to ignore it.
			 */
			if ( char.trim() !== '' && char.charCodeAt() !== 65039 ) {
				arr.push( char );
			}
		}

		return arr;

	},


	/**
	 * Create an emoji regex for splitting the Graphemes.
	 *
	 * Based on the code from here:
	 * @see https://github.com/nota/split-graphemes/blob/master/src/emoji.js
	 * and
	 * @see https://github.com/nota/split-graphemes/blob/master/src/index.js
	 *
	 * @return {object} The regex object for finding the emoji.
	 */
	emojiRegex: function() {

		const countryFlag = '[\\u{1F1E6}-\\u{1F1FF}]{2}';
		const keyCap = '[0-9#\\*][\\u{FE0F}]?\\u{20E3}';

		const emojiRange = [
			'[\\u{2600}-\\u{26FF}]', // Miscellaneous Symbols
			'[\\u{2700}-\\u{27BF}]', // Dingbats
			'[\\u{1F300}-\\u{1F5FF}]', // Miscellaneous Symbols and Pictographs
			'[\\u{1F600}-\\u{1F64F}]', // Emoticons
			'[\\u{1F680}-\\u{1F6FF}]', // Transport and Map Symbols
			'[\\u{1F700}-\\u{1F77F}]', // Alchemical Symbols
			'[\\u{1F900}-\\u{1F9FF}]' // Supplemental Symbols and Pictographs
		];

		const emoji = `(${emojiRange.join( '|' )})`;
		const zeroWidthJoinder = '\\u{200D}';
		const variationSeletor = '[\\u{FE0E}\\u{FE0F}]';
		const skinTone = '[\\u{1F3FB}-\\u{1F3FF}]'

		const emojiVariation = `${emoji}(${zeroWidthJoinder}${emoji}|${skinTone}|${variationSeletor})*`;

		const patterns = [ countryFlag, keyCap, emojiVariation, '.' ];

		return new RegExp( `(${patterns.join( '|' )})`, 'gu' );

	},


	/**
	 * Check to see if an emoji is in the list of available emojis.
	 *
	 * @param {string} emoji The emoji to check.
	 * @return {boolean}
	 */
	emojiExists: function( emoji ) {

		let exists = false;

		emojiListFull.forEach(
			( current ) => {
				if ( current.e === emoji ) {
					exists = true;
					return;
				}
			}
		);

		return exists;

	},


	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		e.stopPropagation();
		e.preventDefault();

		const target = e.target;

		if ( 'button' !== target.localName ) {
			return;
		}

		let art = ninjaData.data.art.clone();

		const x = parseInt( target.getAttribute( 'data-x' ) );
		const y = parseInt( target.getAttribute( 'data-y' ) );

		art[ y ][ x ] = ninjaData.data.currentEmoji;

		ninjaData.setData(
			{
				art
			}
		);

		undo.add();

		document.activeElement.blur();

	},


	/**
	 * Should we update the url?
	 * Debounce so it's not firing rapidly whilst drawing.
	 *
	 * @return {void}
	 */
	maybeUpdateUrl: function() {

		// console.log( 'maybeUpdateUrl' );

		// Debounce the update.
		clearTimeout( drawing.updateUrl_timer );
		drawing.updateUrl_timer = setTimeout( drawing.updateUrl, 750 );

	},


	/**
	 * Actually update the url with the art as a string so it can be displayed.
	 *
	 * @return {void}
	 */
	updateUrl: function() {

		// console.log( 'updateUrl' );

		const url = window.location.origin + window.location.pathname;

		const params = new URLSearchParams(
			{
				bg: ninjaData.data.backgroundColor,
				sz: ninjaData.data.size,
				s: ninjaData.data.currentArtSize,
				l: LZString.compressToEncodedURIComponent( drawing.emojiArtString() ),
			}
		);

		history.replaceState( null, '', url + '?' + params.toString() );

	},


	/**
	 * Move mouse over the canvas.
	 *
	 * @return {void}
	 */
	mouseover: function( e ) {

		if ( !drawing.mousepressed ) {
			return;
		}

		drawing.click( e );

	},


	/**
	 * Click on the canvas.
	 *
	 * @return {void}
	 */
	mousedown: function( e ) {

		drawing.mousepressed = true;
		drawing.click( e );

	},


	/**
	 * Release mouse on the canvas.
	 *
	 * @return {void}
	 */
	mouseup: function( e ) {

		drawing.mousepressed = false;
		ninjaEvent( 'updateDrawing' );

	},


	/**
	 * Get a unique list of the emojis used in the drawing.
	 *
	 * @return {array}
	 */
	getArtEmojis: function() {

		const art = ninjaData.data.art;
		const { width, height } = ninjaData.data;

		let all_emojis = [];
		for ( let y = 0; y < height; y++ ) {
			for ( let x = 0; x < width; x++ ) {

				all_emojis.push( art[ y ][ x ] );

			}
		}

		return all_emojis.unique().sort();

	},

};

